import * as utils from 'Utils';
import pageStore from 'stores/PageStore';

function getPromptHandler() {
  const handler = {};

  handler.setCustomProperties = function(propsData={}) {
    if (!utils.isObject(propsData)) {
      console.error("Expecting object for custom properties");
      return;
    }

    const properties = {};
    try {
      for (var k in propsData) {
        let v = propsData[k];
        properties[k] = v;
      }

      pageStore.setCustomProperties(properties);
    } catch(e) {
      console.error(e);
    }
  };

  handler.onReady = function(callback) {
    pageStore.setOnReadyCallback(callback);
  };

  handler.onPromptDisplay = function(callback) {
    pageStore.setOnPromptDisplayCallback(callback);
  };

  handler.onPromptClose = function(callback) {
    pageStore.setOnPromptCloseCallback(callback);
  };

  handler.onTrackPromptImpression = function(callback) {
    pageStore.setOnTrackPromptImpressionCallback(callback);
  };

  handler.onTrackPromptEngagement = function(callback) {
    pageStore.setOnTrackPromptEngagementCallback(callback);
  };

  handler.onTrackPromptClose = function(callback) {
    pageStore.setOnTrackPromptCloseCallback(callback);
  };

  return handler;
}

// process all queued function calls `apiReady`
export default function apiReady() {
  const handler = getPromptHandler();

  const process = (args) => {
    var params = [].slice.call(args);
    var ns = params.shift();
    var method = params.shift();

    // prompt namespace
    if (ns === "prompt") {
      if (handler[method]) {
       handler[method].apply(handler, params);
      } else {
        console.log(`prompt does not have a ${method} method`);
      }
    }
  };

  if (!window.OnVoardQueue) window.OnVoardQueue = {};
  if (!window.OnVoardApi) window.OnVoardApi = {};

  // process queued function calls
  const queue = window.OnVoardQueue.prompt || [];
  for (var i in queue) {
    process(queue[i]);
  }

  // setup api endpoint after everything is ready
  window.OnVoardApi.prompt = function(args) {
    process(args);
  };

  // this is to support testing api in dev
  if (!utils.isProduction()) {
    window.OnVoard = function() {
      process(arguments);
    };
  }
}
